import { FormConditionalOperator } from 'mapistry-shared';

const OPERATORS_THAT_REQUIRE_EXACT_MATCH = new Set([
  FormConditionalOperator.EQUAL,
  FormConditionalOperator.NOT_EQUAL,
]);
const OPERATORS_THAT_REQUIRE_CONTAINS_MATCH = new Set([
  FormConditionalOperator.CONTAINS,
  FormConditionalOperator.DOES_NOT_CONTAIN,
]);

export function isExactMatchOperator(
  operator: FormConditionalOperator,
): boolean {
  return OPERATORS_THAT_REQUIRE_EXACT_MATCH.has(operator);
}
export function isContainsMatchOperator(
  operator: FormConditionalOperator,
): boolean {
  return OPERATORS_THAT_REQUIRE_CONTAINS_MATCH.has(operator);
}
